import Vue from 'vue'
import Router from 'vue-router'
import $vuex from '@/store'
import login from './login'
import menu from './menu'
import permissions from './permissions'
import roles from './roles'
import user from './user'
import setting from './setting'
import carousel from './carousel'
import adPosition from './ad_position'
import link from './link'
import category from './category'
import article from './article'
import live from './live'
import lecturer from './lecturer'
import statistics from './statistics'
import attachment from './attachment'
import sysLog from './sys_log'
import company from './company'
import openapi from './openapi'
import openapiServer from './openapi_server'
import tradeRecharge from './trade_recharge'
import tradeWithdraw from './trade_withdraw'
import tradeTax from './trade_tax'
import wsAccount from './ws_account'
import settlement from './settlement'
import customer from './customer.js'
import bill from './bill.js'
import account from './account.js'
import task from './task.js'
import review from './review.js'
import inventory from './inventory.js'
import signer from './signer.js'
import missionCenter from './mission_center.js'
import mixRecharge from './mix_recharge.js'
import mixWithdraw from './mix_withdraw.js'
import statement  from './statement.js'
import monthlybill from './monthlybill.js'
import information from './information.js'
import contract from './contract.js'
import bindaccount from './bindaccount.js'
import invoicePartner from './invoice_partner.js'
import adminInvoice from './admin_invoice.js'
import invoice from './invoice.js'
import agreement from './agreement.js'
import audit from './audit.js'
import home from './home.js'
import preview from './preview.js'
import treeTest from './tree_test.js'
import system from './system.js'
import announce from './announce.js'
import channel from './channel.js'
import api_merchant from './api_merchant'
import oem from './oem.js'
import storage from '@/utils/localstorage'
import buser from './buser'
import issuing_agent from './issuing_agent'
import individual from './individual'
import channelrebate from "./channelrebate"
import contract_config from './contract_config'
import Invoicing from './Invoicing'
import taskdetail from './taskdetail'
import Taskaudit from './taskaudit'
import Paihuofeedback from './paihuofeedback.js'
import warningList from './warning_list.js'
import businessapproval from './businessapproval.js'
import paihuo from './paihuo.js'
import settingWhiteList from './settingWhiteList.js'//下发白名单
import boos_white_list from './boos_white_list.js'//董监高
import examineWhiteList from "./auto_examine_white_list.js" //结算批次白名单
import esignWhiteList from "./esign_whiteList.js" //E签宝白名单
import personalTax from "./personalTax.js" //个人完税记录
import laowu from "./laowu.js" //个人完税记录
import individualTax from "./individualTax.js" //个税申报
import addTax from "./addTax.js"  //增值税
import training from "./training.js"  // 培训管理

// 解决vue报错vue-router.esm.js
const routerPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

// 路由详情
const routes = [
  {
    path: '/',
    component: () => import('@/layouts/BasicLayout'),
    meta: {title:'首页'},
    hidden: true,
    children: [
      home,//首页
      menu, // 菜单
      permissions, // 权限
      roles, // 角色
      user, // 用户
      setting, // 基础设置
      carousel, // 轮播图
      adPosition, // 广告位
      link, // 友情链接
      category, // 分类管理
      article, // 文章管理
      live, // 直播管理
      lecturer, // 讲师管理
      statistics, // 统计管理
      attachment, // 附件管理
      sysLog, // 系统日志
      company, // 公司管理
      openapi, // 开放平台配置管理
      openapiServer, // 开放平台配置管理
      tradeRecharge, // 充值流水管理
      tradeWithdraw, // 交易流水管理
      tradeTax, // 交易流水管理
      wsAccount, // 网商子账号
      settlement, // 银行中心->账户资料
      customer,//人才签约
      bill,//结算清单管理
      task,//任务结算
      review,//结算审核
      account,//账号管理
      inventory,//结算单记录
      signer,//签约人员查看
      missionCenter,//任务中心
      mixRecharge,//充值记录
      mixWithdraw,//发放明细
      statement,//结算单记录
      monthlybill,//月度账单
      information,//账号信息
      contract,//绑定合同
      bindaccount,//绑定账号
      invoicePartner,//开票管理
      adminInvoice,//开票审核
      invoice,//在线开票
      Invoicing,//发票代开
      Taskaudit,//任务审核
      audit,//各种审核
      preview,//各种预览
      treeTest,//树形结构
      system,//后台公告
      contract_config,//签约配置
      announce,//公告管理
      oem,//oem申请
      channel,//渠道商户
      taskdetail,//任务审核详情
      api_merchant,//api商户
      buser,//b端用户管理
      issuing_agent,//代开
      individual,
      channelrebate, //渠道返佣
      warningList,
      businessapproval,
		paihuo,//派活
		Paihuofeedback,//派活反馈
		settingWhiteList,//下发白名单
		boos_white_list,//董监高
      examineWhiteList,//结算批次白名单
      esignWhiteList,
      personalTax,
      laowu,
	...	individualTax,
	addTax,
	training, // 培训管理
      {
        path: 'exception/404',
        component: () => import(/* webpackChunkName: "exception-404" */ '@/pages/exception/404')
      }
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/PassportLayout'),
    children: [
      login, // 登录
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/ContractLayout'),
    children: [
      agreement, // 合同
    ]
  },
  {
    path:"*",
    redirect:'/exception/404',
    // component: () => import('@/pages/exception/404')
  }
]

// 实例化
const router = new Router({
  base : process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/',
  mode : 'history',
  routes
})

// 路由钩子
router.beforeEach((to, from, next) => {
  ifLogin(to, next)
  handelSiderMenu(to)
  next()
});

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 */
let handelSiderMenu =  (to) => {
  $vuex.commit('handleRoutePath', to.path)
}

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 * @param {*} next 回调函数
 */
let ifLogin = (to, next) => {
  let userInfo = storage.get('user_info')
  // 判断是否是登录页
  let idx = to.path.indexOf('login') != -1
   // 没有userInfo 且 不是login 页 => 登录页
  if (!userInfo && !idx) {
    next('/login')
  }
  // 有userinfo 且 是login 页 => 首页
  if (idx && userInfo) {
    next('/')
  }
}

export default router
